import { Controller } from '@hotwired/stimulus'
import { includes } from 'lodash'

export default class extends Controller {
  static targets = ['container', 'content', 'trigger']

  connect() {
    document.addEventListener('click', this.onExternalClick)
    document.addEventListener('touch', this.onExternalClick)
  }

  disconnect(event) {
    this.close(event);
  }

  onTriggerClick = event => {
    if (event.target.classList.contains('stop-propagation')) {
      event.stopPropagation()
    }
    if (!includes(this.contentTarget.classList, 'hidden')) {
      this.close()
      return
    }
    event.stopPropagation()
    this.open()
  }

  onExternalClick = event => {
    if (event && (this.contentTarget.contains(event.target) || this.triggerTarget.contains(event.target))) {
      return;
    }

    this.close()
  }

  open = () => this.contentTarget.classList.remove('hidden')
  close = () => this.contentTarget.classList.add('hidden')
}


